import { render } from "./NewAsideHistoryChart.vue?vue&type=template&id=2d089063&scoped=true"
import script from "./NewAsideHistoryChart.vue?vue&type=script&lang=js"
export * from "./NewAsideHistoryChart.vue?vue&type=script&lang=js"

import "./NewAsideHistoryChart.vue?vue&type=style&index=0&id=2d089063&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d089063"]])

export default __exports__